export default __webpack_public_path__ + "static/media/sabor-icon.fedffc65.svg";